<template>
  <svg
    :width="size * 1.33"
    :height="size"
    viewBox="0 0 32 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26.35 3.5C20.1667 3.5 19.1833 3.5 13 3.5C7.75329 3.5 3.5 7.75329 3.5 13C3.5 18.2467 7.75329 22.5 13 22.5H17"
      :stroke="color"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M29.3549 2.93557L27.2439 1.08839C26.7589 0.664074 26 1.00846 26 1.65283V5.34717C26 5.99154 26.7589 6.33593 27.2439 5.91161L29.3549 4.06443C29.6964 3.76562 29.6964 3.23438 29.3549 2.93557Z"
      :fill="color"
    />
    <path
      d="M11.9726 13.604C13.1366 13.604 13.4606 14.036 13.4606 14.732C13.4606 15.368 13.1006 15.86 12.1646 15.86C11.2766 15.86 10.8686 15.488 10.9406 14.672H9.20064C8.96064 16.376 9.83664 17.156 12.0686 17.156C14.2406 17.156 15.2246 16.184 15.2246 14.72C15.2246 13.532 14.5886 12.944 13.4966 12.8V12.776C14.3726 12.548 14.9846 11.888 14.9846 10.952C14.9846 9.716 14.2646 8.888 12.2246 8.888C10.3046 8.888 9.21264 9.68 9.28464 11.288H10.9886C10.9646 10.652 11.2526 10.172 12.1166 10.172C12.8606 10.172 13.2206 10.52 13.2206 11.204C13.2206 11.816 12.8726 12.26 11.9726 12.26H10.8806V13.604H11.9726ZM19.2417 17.156C21.1977 17.156 22.5057 15.968 22.5057 12.908C22.5057 9.98 21.4257 8.888 19.3737 8.888C17.4057 8.888 16.0977 10.064 16.0977 13.124C16.0977 16.052 17.1897 17.156 19.2417 17.156ZM19.2897 15.824C18.3657 15.824 17.8737 15.248 17.8737 13.04C17.8737 10.856 18.4017 10.22 19.3137 10.22C20.2377 10.22 20.7417 10.796 20.7417 12.992C20.7417 15.2 20.2017 15.824 19.2897 15.824Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  props: {
    size: {
      type: Number,
      default: 24
    },
    color: {
      type: String,
      default: 'currentColor'
    }
  }
}
</script>
